import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IActivityLocation, IPhoto } from '@curbnturf/entities';
import { Observable } from 'rxjs';
import { BASE_API_URL } from '../network/api-config';

const API_URL = BASE_API_URL + 'activity-location';

/**
 * Local fork of @curbnturf/activity's ActivityService — trimmed to plain
 * HttpClient. Covers POI favoriting (used by FavoritesService) plus the
 * fetch/create/update/photo methods the cnt-landing activity-location view
 * and add/edit pages need; search/preload/offline-cache methods aren't
 * needed (no POI list/search view in cnt-landing).
 */
@Injectable({ providedIn: 'root' })
export class ActivityApiService {
  private readonly http = inject(HttpClient);

  fetch(id: number): Observable<IActivityLocation> {
    return this.http.get<IActivityLocation>(`${API_URL}/${id}`);
  }

  create(activity: IActivityLocation): Observable<IActivityLocation> {
    return this.http.post<IActivityLocation>(API_URL, activity);
  }

  update(id: number, activity: IActivityLocation): Observable<IActivityLocation> {
    return this.http.put<IActivityLocation>(`${API_URL}/${id}`, activity);
  }

  uploadImage(id: number, formData: FormData): Observable<{ activityId: number; photos: IPhoto[] }> {
    return this.http.post<{ activityId: number; photos: IPhoto[] }>(`${API_URL}/${id}/upload-image`, formData);
  }

  removeImage(id: number, photoIndex: number): Observable<IPhoto[]> {
    return this.http.delete<IPhoto[]>(`${API_URL}/${id}/remove-image/${photoIndex}`);
  }

  favorite(activity: IActivityLocation): Observable<{ success: boolean; message: string }> {
    return this.http.post<{ success: boolean; message: string }>(`${API_URL}/${activity.id}/favorite`, null);
  }

  unfavorite(activity: IActivityLocation): Observable<{ success: boolean; message: string }> {
    return this.http.post<{ success: boolean; message: string }>(`${API_URL}/${activity.id}/unfavorite`, null);
  }
}
